<template>
  <div class="tool-tip-container">
    <div v-if="showToolTipOverlay" @click="toggleToolTip()" class="tool-tip-overlay"></div>
    <span v-if="!isMobile" v-bind="toolTipInfo()"><i class="fa-regular fa-circle-info"></i></span>
    <span v-else @click="toggleToolTip()" :data-balloon-visible="showToolTip" data-balloon-blunt="true" v-bind="toolTipInfo()"><i class="fa-regular fa-circle-info"></i></span>
  </div>
</template>

<script>
import userAgent from '@/libs/user-agent'
// for documentation, see:
// https://kazzkiq.github.io/balloon.css/

export default {
  props: {
    toolTipText: {
      type: String,
      required: true
    },
    position: {
      type: String
    },
    length: {
      type: String
    }
  },
  data: function () {
    return {
      showToolTip: false,
      showToolTipOverlay: false
    }
  },
  computed: {
    isMobile: function () {
      return userAgent.isIOS() || userAgent.isAndroid()
    }
  },
  methods: {
    toggleToolTip: function () {
      this.showToolTip = !this.showToolTip
      this.showToolTipOverlay = !this.showToolTipOverlay
    },
    toolTipInfo: function () {
      const toolTip = {}
      toolTip['data-balloon'] = this.toolTipText
      toolTip['data-balloon-pos'] = this.position ? this.position : 'up-left'
      toolTip['data-balloon-length'] = this.length ? this.length : (this.isMobile ? 'large' : 'xlarge')
      return toolTip
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-tip-container {
  display: inline-block;
}
.tool-tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100vh;
}
</style>
